import { render, staticRenderFns } from "./DeleteShiftsPopup.vue?vue&type=template&id=71249566"
import script from "./DeleteShiftsPopup.vue?vue&type=script&lang=ts"
export * from "./DeleteShiftsPopup.vue?vue&type=script&lang=ts"
import style0 from "./DeleteShiftsPopup.vue?vue&type=style&index=0&id=71249566&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports